/* Pli Pilates : un lien vers #ancre d'un onglet d'accordéon l'ouvre et y fait défiler la page. */
(() => {
  const open = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    const el = document.getElementById(id);
    if (!el || el.tagName !== 'DETAILS') return;
    el.open = true;
    let parent = el.parentElement && el.parentElement.closest('details');
    while (parent) { parent.open = true; parent = parent.parentElement && parent.parentElement.closest('details'); }
    requestAnimationFrame(() => el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }));
  };
  window.addEventListener('hashchange', open);
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.pathname !== location.pathname || a.hash !== location.hash) return;
    setTimeout(open, 0); // même ancre cliquée deux fois : hashchange ne se déclenche pas
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open); else open();
})();
